import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { useState } from "react";

export default function FuelCheckoutForm({ onPaymentSuccess }) {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setIsProcessing(true);
    setError("");

    const { error: stripeError } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/fuel-up/success`,
      },
      redirect: "if_required",
    });

    if (stripeError) {
      setError(stripeError.message);
      setIsProcessing(false);
      return;
    }

    setIsProcessing(false);
    // FIXED: Call the parent success function instead of tracking local success
    if (onPaymentSuccess) {
      onPaymentSuccess();
    }
  };

  return (
    <form className="fuel-card fuel-fade-in" onSubmit={handleSubmit}>
      <h2>Payment Details</h2>
      <PaymentElement />
      {error && <div className="fuel-error">{error}</div>}
      <button
        className="fuel-primary-btn"
        type="submit"
        disabled={!stripe || isProcessing}
      >
        {isProcessing ? "Processing..." : "Fuel the Car"}
      </button>
    </form>
  );
}
